/**
 * API 작업 재시도 유틸리티
 *
 * @description
 * 실패한 API 작업을 지정된 횟수만큼 재시도합니다.
 * MLflow 동기화 등 외부 API 호출 시 네트워크 불안정성을 처리하기 위해 사용됩니다.
 *
 * @template T - 작업 반환 타입
 * @param operation - 재시도할 비동기 작업
 * @param maxRetries - 최대 재시도 횟수 (기본값: 1)
 * @returns 작업 성공 시 결과값
 * @throws 모든 재시도 실패 시 마지막 에러
 *
 * @example
 * ```typescript
 * const result = await retryOperation(
 *   () => apiClient.post('/endpoint', data),
 *   1
 * );
 * ```
 */
export const retryOperation = async <T>(operation: () => Promise<T>, maxRetries = 1): Promise<T> => {
  try {
    return await operation();
  } catch (error) {
    if (maxRetries > 0) {
      console.warn('Operation failed, retrying...', error);
      return await retryOperation(operation, maxRetries - 1);
    }
    throw error;
  }
};
